import React from 'react'

interface KeyboardShortcutKeyAnnotationProps {
  /** The keyboard shortcut text to display (e.g., "1", "Ctrl+S", "⌘K") */
  shortcut: string
  /** Additional CSS styles to apply */
  style?: React.CSSProperties
  /** CSS class name */
  className?: string
}

/**
 * A styled component for displaying keyboard shortcuts in tooltips, menus, and UI elements
 *
 * @example
 * ```tsx
 * <KeyboardShortcutKeyAnnotation shortcut="1" />
 * <KeyboardShortcutKeyAnnotation shortcut="Ctrl+S" />
 * <KeyboardShortcutKeyAnnotation shortcut="⌘K" style={{ marginLeft: '12px' }} />
 * ```
 */
export const KeyboardShortcutKeyAnnotation: React.FC<
  KeyboardShortcutKeyAnnotationProps
> = ({ shortcut, style, className }) => {
  return (
    <kbd
      className={className}
      style={{
        fontSize: '11px',
        background: 'grey',
        padding: '1px 4px',
        borderRadius: '4px',
        color: 'white',
        fontFamily: 'monospace',
        fontWeight: 'normal',
        border: 'none',
        ...style,
      }}
    >
      {shortcut}
    </kbd>
  )
}
